
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface LanguageBadgeProps {
  language: string;
  variant?: 'default' | 'secondary' | 'outline';
  size?: 'sm' | 'md';
}

export const LanguageBadge = ({ language, variant = 'secondary', size = 'sm' }: LanguageBadgeProps) => {
  return (
    <Badge 
      className={`${size === 'sm' ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1'} font-medium bg-purple-500 hover:bg-purple-600 text-white`}
    >
      {language}
    </Badge>
  );
};

interface LanguageBadgeListProps {
  languages: string[];
  maxVisible?: number;
  showTooltip?: boolean;
  variant?: 'default' | 'secondary' | 'outline';
  size?: 'sm' | 'md';
}

export const LanguageBadgeList = ({ 
  languages = [], 
  maxVisible = 3, 
  showTooltip = true,
  variant = 'secondary',
  size = 'sm'
}: LanguageBadgeListProps) => {
  if (!languages || languages.length === 0) return null;

  const visibleLanguages = languages.slice(0, maxVisible);
  const hiddenLanguages = languages.slice(maxVisible);

  return (
    <div className="flex flex-wrap gap-1">
      {visibleLanguages.map((language, index) => (
        <LanguageBadge 
          key={index} 
          language={language} 
          variant={variant}
          size={size}
        />
      ))}
      
      {hiddenLanguages.length > 0 && showTooltip && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge 
                className={`${size === 'sm' ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1'} cursor-help border-dashed bg-purple-500 hover:bg-purple-600 text-white`}
              >
                +{hiddenLanguages.length} idiomas
              </Badge>
            </TooltipTrigger>
            <TooltipContent>
              <div className="max-w-xs">
                <p className="font-medium mb-1">Outros idiomas:</p>
                <div className="flex flex-wrap gap-1">
                  {hiddenLanguages.map((language, index) => (
                    <span key={index} className="text-xs">
                      {language}{index < hiddenLanguages.length - 1 ? ', ' : ''}
                    </span>
                  ))}
                </div>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};
